<template>
  <div class="up-teaching-plan">
    <HeadBtn :searchList='searchList' @addBtn='addBtn' @resetBtn="resetBtn" :defaultProps='defaultProps'
      :searchForm='searchForm' @searchFormData='searchFormData' :selectDict='selectDict' />

    <AddTestPaper @addSuccess='addSuccess' :rowData='rowData' :type='type'
      :centerDialogVisible.sync='centerDialogVisible' :form='form' :formList='formList' :selectDict='selectDict' />

    <Table :tableData='tableData' :tableHeadList='tableHeadList' :isBooks='false' @handleDelete='handleDelete' />
  </div>
</template>
<script>
import HeadBtn from "@/views/profile/components/mine/myUpload/common/HeadBtn";
import AddTestPaper from "@/views/profile/components/mine/myUpload/testPaper/components/AddTestPaper";
import Table from "@/views/profile/components/mine/myUpload/common/Table";
import {
  getPaperAdmin,
  delResource,
  getDictBatch,
  IdGetResource
} from "@/network/resourceRequest/api";
import utils from "@/util/index";

export default {
  name: "UpTestPaper",
  components: {
    HeadBtn,
    AddTestPaper,
    Table
  },

  props: {
    //当前页面--------------------------------------------
    currentPage: {},
    //总页码--------------------------------------------
    pageTotal: {}
  },

  data() {
    return {
      tableData: [],
      //表格头部--------------------------------------------
      tableHeadList: [
        {
          prop: "name",
          label: "试卷名称"
        },
        {
          prop: "course",
          label: "科目"
        },
        {
          prop: "phase",
          label: "学段"
        },
        {
          prop: "grade",
          label: "年级"
        },
        {
          prop: "edition",
          label: "版本"
        },
        {
          prop: "volume",
          label: "册别"
        }
      ],

      //筛选条件--------------------------------------------
      fd: {
        pageNum: 1,
        pageSize: 8
      },

      //搜索条件--------------------------------------------
      searchForm: {},

      //树形筛选结构
      defaultProps: {
        children: "children",
        label: "name",
        value: "id",
        emitPath: false
      },

      //文件信息
      form: {
        name: "", //资源名称
        srcSchool: "", //来源学校名称
        number: "", //题量
        year: "",
        course: "", //科目
        phase: "", //学段
        grade: "", //年级
        volume: "", //册别
        edition: "", //版本
        chapterId: 0, //章节ID
        type: "教案",
        toll: "", //是否收费
        openState: 1, //公开状态
        fileId: "", //文件id凭证
        fileIdList: [], //文件id列表
        coverId: "", //封面id凭证
        id: 0, //资源id
        label: "", //标签属性
        paperType: "" //试卷类型
      },

      //渲染表单列表
      formList: [
        {
          field: "name",
          type: "input",
          label: "试卷标题：",
          placeholder: "填写试卷标题"
        },
        {
          field: "srcSchool",
          type: "input",
          label: "学校：",
          placeholder: "填写学校名称"
        },
        {
          field: "number",
          type: "input",
          label: "题量：",
          placeholder: "填写题目数量"
        },
        {
          field: "year",
          type: "option",
          label: "年份：",
          placeholder: "选择年份",
          optionList: [
            { name: 2020 },
            { name: 2019 },
            { name: 2018 },
            { name: 2017 },
            { name: 2016 },
            { name: 2015 },
            { name: 2014 },
            { name: 2013 },
            { name: 2012 }
          ]
        },
        {
          field: "phase",
          type: "option",
          label: "学段：",
          placeholder: "选择学段",
          optionList: []
        },
        {
          field: "course",
          pField: "phase",
          type: "option",
          label: "科目：",
          placeholder: "选择科目",
          pPlaceholder: "请先选择学段",
          optionList: []
        },
        {
          field: "edition",
          pField: "course",
          type: "option",
          label: "版本：",
          placeholder: "选择册别",
          pPlaceholder: "请先选择科目",
          optionList: []
        },
        {
          field: "grade",
          pField: "edition",
          type: "option",
          label: "年级：",
          placeholder: "选择年级",
          pPlaceholder: "请先选择版本",
          optionList: []
        },
        {
          field: "volume",
          pField: "grade",
          type: "option",
          label: "册别：",
          placeholder: "选择册别",
          pPlaceholder: "请先选择年级",
          optionList: []
        },
        {
          field: "paperType",
          type: "option",
          label: "试卷类型：",
          placeholder: "选择试卷类型",
          optionList: []
        }
      ],

      //渲染表单列表
      searchList: [
        {
          field: "name",
          type: "input",
          label: "试卷标题：",
          placeholder: "填写试卷标题"
        },
        {
          field: "srcSchool",
          type: "input",
          label: "学校：",
          placeholder: "填写学校名称"
        },
        {
          field: "number",
          type: "input",
          label: "题量：",
          placeholder: "填写题目数量"
        },
        {
          field: "year",
          type: "option",
          label: "年份：",
          placeholder: "选择年份",
          optionList: [
            { name: 2020 },
            { name: 2019 },
            { name: 2018 },
            { name: 2017 },
            { name: 2016 },
            { name: 2015 },
            { name: 2014 },
            { name: 2013 },
            { name: 2012 }
          ]
        },
        {
          field: "phase",
          type: "option",
          label: "学段：",
          placeholder: "选择学段",
          optionList: []
        },
        {
          field: "course",
          pField: "phase",
          type: "option",
          label: "科目：",
          placeholder: "选择科目",
          pPlaceholder: "请先选择学段",
          optionList: []
        },
        {
          field: "edition",
          pField: "course",
          type: "option",
          label: "版本：",
          placeholder: "选择册别",
          pPlaceholder: "请先选择科目",
          optionList: []
        },
        {
          field: "grade",
          pField: "edition",
          type: "option",
          label: "年级：",
          placeholder: "选择年级",
          pPlaceholder: "请先选择版本",
          optionList: []
        },
        {
          field: "volume",
          pField: "grade",
          type: "option",
          label: "册别：",
          placeholder: "选择册别",
          pPlaceholder: "请先选择年级",
          optionList: []
        },
        {
          field: "paperType",
          type: "option",
          label: "试卷类型：",
          placeholder: "选择试卷类型",
          optionList: []
        }
      ],

      //添加还是修改--------------------------------------------
      type: "",
      //编辑的数据--------------------------------------------
      rowData: "",

      //筛选字典--------------------------------------------
      selectDict: [],

      //是否显示弹框
      centerDialogVisible: false
    };
  },

  created() {
    //初始化数据--------------------------------------------
    this._initData();
    this._getTableData();
  },

  watch: {
    currentPage(newPage) {
      this.$set(this.fd, "pageNum", newPage);
      this._getTableData();
    }
  },

  methods: {
    _initData() {
      //类型:course学科,phase学段,grade年级,volume册别,edition教材版本,textbook_label教材性质,qtype题型,rtype同步资源类型,ftype文件格式类型,ptype卷库类型
      let data = {
        types: "course,phase,grade,volume,edition,ptype"
      };

      getDictBatch(data).then(res => {
        if (res.data.success) {
          this.selectDict = res.data.data;
          this.formList.forEach((item, index) => {
            if (item.field == "paperType") {
              this.$set(
                this.formList[index],
                "optionList",
                res.data.data.ptype
              );
              this.$set(
                this.searchList[index],
                "optionList",
                res.data.data.ptype
              );
            }
          });
        }
      });
    },

    //添加按钮
    addBtn() {
      this.type = "add";
      this.centerDialogVisible = true;
    },

    //添加成功更新表格
    addSuccess() {
      this._getTableData();
    },

    //查询按钮返回的数据
    searchFormData(searchFormData) {
      this.fd = {
        type: "试卷",
        pageNum: 1,
        pageSize: 8
      };
      for (const key in searchFormData) {
        if (
          searchFormData.hasOwnProperty(key) &&
          searchFormData[key] &&
          searchFormData[key] != "全部"
        ) {
          this.fd[key] = searchFormData[key];
        }
      }
      this._getTableData();
    },

    //重置表格数据
    resetBtn() {
      this.searchForm = {};
      this.fd = {
        type: "试卷",
        pageNum: 1,
        pageSize: 8
      };
      this.$emit("update:currentPage", 1);
      this._getTableData();
    },

    //获取表格数据--------------------------------------------
    _getTableData() {
      getPaperAdmin(this.fd).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list;
          this.$emit("update:pageTotal", res.data.data.total);
        } else {
          console.log("CoTextbook", res.data.code);
        }
      });
    },

    //取消收藏 (1编辑  2删除)
    handleDelete(scope, type) {
      if (type == 1) {
        IdGetResource("paper", scope.row.id).then(res => {
          this.rowData = res.data.data;
          this.type = "set";
          this.form.id = res.data.data.id;
          for (const key in this.form) {
            if (this.form.hasOwnProperty(key)) {
              this.$set(
                this.form,
                key,
                res.data.data.hasOwnProperty(key) ? res.data.data[key] : ""
              );
            }
          }
          this.centerDialogVisible = true;
        });
      }
      //删除
      if (type == 2) {
        delResource("paper", scope.row.id).then(res => {
          if (res.data.success) {
            utils.tips("success", res.data.code);
            //更新
            this._getTableData();
          } else {
            console.log("CoTextbook", res.data.code);
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
</style>